import { Alert, Button } from "@mantine/core";
import { useGetSmsPlaceHolder } from "@/services/smsPlaceHolders/hooks/useGetSmsPlaceHolder";
import { useCheckEmptyPreviewTags } from "@/components/checkEmptyPreviewTags";
import { EmptyPreviewTagsAlert } from "@/components/emptyPreviewTagsAlert";
// `perRecipient`: placeholders the server fills for each customer at send time, so an empty preview is fine.
export function useTemplateValidation(text?: string | null, perRecipient: string[] = []) {
 const tags=useGetSmsPlaceHolder();
 const checked=(tags.data ?? []).filter(tag=>!perRecipient.some(key=>tag.key?.includes(key)));
 const check=useCheckEmptyPreviewTags({tags:checked,templateText:text ?? ""});
 return {blocked:!text || !tags.isSuccess || check.hasEmptyPreviewTags, alert:<>{tags.isError && <Alert color="red">اطلاعات پیش‌نمایش دریافت نشد.<Button variant="subtle" onClick={()=>void tags.refetch()}>تلاش دوباره</Button></Alert>}<EmptyPreviewTagsAlert emptyTags={check.checkEmptyPreviewTags}/></>};
}
